// extracted by mini-css-extract-plugin
export default {"Recomended":"Recomended_Recomended__HAyeD","RecomendedItemContainer":"Recomended_RecomendedItemContainer__S9bWn"};